import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d6936ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body row row-cols-1 row-cols-md-2" }
const _hoisted_3 = { class: "d-flex justify-content-center align-items-center flex-column" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Machines", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-100",
  src: "/media/modern/machine_icon.png",
  alt: "Machines Icon"
}, null, -1))
const _hoisted_6 = { class: "fs-3" }
const _hoisted_7 = { class: "d-flex justify-content-center align-items-center flex-column" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Challenges", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "h-100",
  src: "/media/modern/challenge_icon.png",
  alt: "Challenges Icon"
}, null, -1))
const _hoisted_10 = { class: "fs-3" }

import { IPublicUser } from '@/modern/types/dashboard';



export default /*#__PURE__*/_defineComponent({
  props: {
    challenges_completed: null,
    total_challenges: null,
    machines_completed: null,
    total_machines: null
  },
  setup(__props: any) {

const props = __props as {
    challenges_completed: IPublicUser['challenges_completed']
    total_challenges: IPublicUser['total_challenges']
    machines_completed: IPublicUser['machines_completed']
    total_machines: IPublicUser['total_machines']
}



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(props.machines_completed) + " / " + _toDisplayString(props.total_machines), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _hoisted_9,
        _createElementVNode("div", null, [
          _createElementVNode("span", _hoisted_10, _toDisplayString(props.challenges_completed) + " / " + _toDisplayString(props.total_challenges), 1)
        ])
      ])
    ])
  ]))
}
}

})